module.exports = __webpack_public_path__ + "img/preferences-en.2f6215dd.png";